import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import the components for different pages
import Home from '../Components/Home';
import About from '../Components/About';
import Contact from '../Components/Contact';
import NotFound from '../Components/Not_Found';  // For handling 404 pages
import Signin from '../Components/Signin'
import OurServices from '../Components/OurServices';
import ChampionsForgeSection from '../Feature/ChampionsForge/ChampionsForge';
import Careers from '../Components/Careers';
import Shop from '../Components/Shop';
import ComingSoon from '../Components/ComingSoon';

// Define Routes component that handles routing for different pages
const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/ourservices" element={<OurServices />} />
            <Route path="/championsforge" element={<ChampionsForgeSection />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default AppRoutes;
